export default function Contact() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-[420px] flex-shrink-0">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 border border-secondary-200 mb-4">
              <i className="ri-mail-send-line text-secondary-600 text-sm"></i>
              <span className="text-xs font-medium text-secondary-700 whitespace-nowrap">商务合作</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50 mb-3">
              联系我们
            </h2>
            <p className="text-sm md:text-base text-foreground-200 mb-8 leading-relaxed">
              如果您有影片推荐、内容合作或其他建议，欢迎通过以下方式与无极电影网取得联系。我们期待听到每一位影迷的声音。
            </p>

            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3 p-4 rounded-xl bg-background-100 border border-background-200/60">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100">
                  <i className="ri-mail-line text-primary-600 text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-50">电子邮箱</h3>
                  <p className="text-sm text-foreground-200 mt-0.5">contact@wujimovie.com</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 rounded-xl bg-background-100 border border-background-200/60">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl bg-accent-100">
                  <i className="ri-wechat-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-50">微信公众号</h3>
                  <p className="text-sm text-foreground-200 mt-0.5">无极电影网官方</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 rounded-xl bg-background-100 border border-background-200/60">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl bg-secondary-100">
                  <i className="ri-weibo-line text-secondary-600 text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-50">官方微博</h3>
                  <p className="text-sm text-foreground-200 mt-0.5">@无极电影网</p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1">
            <div className="bg-background-100 rounded-2xl border border-background-200/60 p-6 md:p-8">
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-50 mb-6">
                发送消息
              </h3>
              <form
                data-readdy-form
                action="https://readdy.ai/api/form/d9mrdhcit35ii3jdll50"
                method="POST"
                encType="application/x-www-form-urlencoded"
                className="flex flex-col gap-4"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-foreground-100 mb-1.5">姓名</label>
                    <input
                      type="text"
                      name="name"
                      placeholder="您的称呼"
                      className="w-full px-4 py-2.5 text-sm rounded-xl border border-background-300 bg-background-50 text-foreground-50 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 transition-colors"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-foreground-100 mb-1.5">邮箱</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="your@email.com"
                      className="w-full px-4 py-2.5 text-sm rounded-xl border border-background-300 bg-background-50 text-foreground-50 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 transition-colors"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-100 mb-1.5">主题</label>
                  <input
                    type="text"
                    name="subject"
                    placeholder="消息主题"
                    className="w-full px-4 py-2.5 text-sm rounded-xl border border-background-300 bg-background-50 text-foreground-50 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-100 mb-1.5">消息内容</label>
                  <textarea
                    name="message"
                    rows={4}
                    maxLength={500}
                    placeholder="请输入您想说的话..."
                    className="w-full px-4 py-2.5 text-sm rounded-xl border border-background-300 bg-background-50 text-foreground-50 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                  ></textarea>
                </div>
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="honeypot-field"
                />
                <button
                  type="submit"
                  className="w-full py-3 text-sm font-semibold whitespace-nowrap rounded-xl bg-primary-500 text-foreground-950 cursor-pointer hover:bg-primary-400 transition-all duration-200 active:scale-[0.98]"
                >
                  <i className="ri-send-plane-line mr-2"></i>
                  发送消息
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}